import React, { useEffect } from 'react';
import Error from './TemplateError/index';
import { useStateContext } from '@merchant-portal/framework';

const styles = {
  flex: '1 0 auto',
};

const AppError = props => {
  const { setState: setFrameworkState = x => x } = useStateContext();
  useEffect(() => setFrameworkState({ hideSidebar: true }), []);

  return (
    <div style={styles}>
      <Error {...props} />
    </div>
  );
};

export default AppError;
